import { ajaxGetAnon } from './AjaxHelper.js';
declare var $;
declare var Cookies;

//import update from 'immutability-helper';

export function getJobDetail(id, languageId, callback) {
    ajaxGetAnon("/api/jobs/" + id + "?language=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}


// WEBPACK FOOTER //
// ./src/Api/Jobs.js